<template>
    <v-container fluid>
        <v-card>
            <v-container fluid>
                <no-data-dialog v-if="notifyDialog" @input="notifyDialog = false" />
                <message-dialog v-if="messageDialog" @input="messageDialog = false">
                    <template v-slot:title>
                        Invalid Operation
                    </template>
                    Member does not have any audits
                </message-dialog>
                <v-dialog v-model="auditDialog" max-width="500px">
                    <audit-form :filter="auditFilter" @input="onSave" @cancel="auditDialog = false" />
                </v-dialog>
                <v-row>
                    <v-col>
                        <h2>Audit Members</h2>
                        Choose a member to audit
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="search" append-icon="mdi-search" label="Search" single-line hide-details />
                    </v-col>
                    <v-col>
                        <v-btn color="quaternary" dark class="ml-2 float-right" v-on:click="download">Export to Excel</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table class="edit-data-table" :headers="filteredHeaders" :items="computedItems" :loading="loading" item-key="id" :show-expand="showExpand" single-expand>
                            <template v-slot:[`item.contactId`]="{ item }">
                                {{ contacts[item.contactId] }}
                            </template>
                            <template v-slot:[`item.address`]="{ item }">
                                {{ addresses[item.contactId] }}
                            </template>
                            <template v-slot:[`item.lastAudit`]="{ item }">
                                {{ formatDate(getAuditStart(item)) }}
                            </template>
                            <template v-if="canRead('Members')" v-slot:[`item.action`]="{ item }">
                                <div class="d-flex flex-nowrap justify-end">
                                    <v-btn color="tertiary" dark class="mr-2" @click="addItem(item.id)">New Audit</v-btn>
                                    <v-btn color="tertiary" dark class="mr-2" @click="goToLastAudit(item.id)">View Last Audit</v-btn>
                                    <v-btn color="tertiary" dark class="mr-2" @click="goToCARs(item.id)">Outstanding CARs</v-btn>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import exporter from '../export/exporter'
    import errorUtility from '../services/errorUtility'
    import securityService from '../services/securityService'

    export default {
        props: [
            'filter',
            'showExpand'
        ],

        components: {
            noDataDialog: () => import('../export/NoDataDialog'),
            messageDialog: () => import('../components/MessageDialog'),
            auditForm: () => import('../forms/AuditForm')
        },

        data() {
            return {
                loading: true,
                search: '',
                headers: [
                    { text: 'Member Name', value: 'contactId' },
                    { text: 'Membership Number', value: 'membershipNumber' },
                    { text: 'Address', value: 'address' },
                    { text: 'Last Audit', value: 'lastAudit' },
                    { text: '', value: 'action' }
                ],
                items: [],
                contacts: [],
                addresses: [],
                audits: [],

                notifyDialog: false,
                messageDialog: false,
                auditDialog: false,
                auditFilter: null,
                auditorId: null
            }
        },

        mounted() {
            this.auditorId = securityService.getAuditorId();
            this.dialog = false;
            this.load();
        },

        methods: {
            async load() {
                try {
                    this.loading = true;
                    var params = {};
                    var filter = this.filter;
                    if (typeof this.filter !== 'undefined' && this.filter !== null) {
                        Object.keys(this.filter).forEach(key => params['filter.' + key] = this.filter[key]);
                    }
                    var response = await axios.get('/api/Members', { params });
                    if (JSON.stringify(filter) !== JSON.stringify(this.filter)) {
                        return;
                    }
                    var data = response.data;

                    this.contacts = data.contacts;
                    this.addresses = data.addresses;
                    this.items = data.items;

                    params = {};
                    params['filter.auditorId'] = this.auditorId;
                    var auditResponse = await axios.get('/api/Audits/LastAudits', { params });
                    this.audits = auditResponse.data;
                } catch (error) {
                    errorUtility.handleServerError(error);
                } finally {
                    this.loading = false;
                }
            },

            download() {
                if (!this.computedItems || this.computedItems.length === 0) {
                    this.notifyDialog = true;
                    return;
                }
                var items = this.computedItems.map(i => {
                    return {
                        'Id': i.id,
                        'Contact Id': i.contactId,
                        'Contact': this.contacts[i.contactId],
                        'Membership Number': i.membershipNumber
                    }
                });
                var title = "Members";

                exporter.downloadAsExcel({ title, items });
            },

            addItem(id) {
                this.auditFilter = { memberId: id };
                if (this.auditorId) {
                    this.auditFilter.auditorId = this.auditorId;
                }
                this.auditDialog = true;
            },

            async goToLastAudit(id) {
                var audit = this.audits.filter(i => i.memberId === id);
                if (audit.length !== 1) {
                    this.messageDialog = true;
                    return;
                }
                this.$router.push({
                    name: 'audit',
                    params: {
                        id: audit[0].id
                    }
                });
            },

            async goToCARs(id) {
                var filter = {
                    memberId: id
                };
                this.$router.push({
                    name: 'correctiveActionRequests',
                    query: { filter }
                })
            },

            getAuditStart(item) {
                var audit = this.audits.filter(i => i.memberId === item.id);
                if (audit.length !== 1) { return null; }
                return audit[0].startedOn;
            },

            onSave(item) {
                this.auditDialog = false;
                this.loading = true;
                this.$router.push({
                    name: 'auditEditor',
                    params: {
                        id: item.id
                    }
                });
            },

            onDelete(item) {
                var index = this.items.findIndex(i => i.id === item.id);

                if (index > -1) {
                    this.items.splice(index, 1);
                }
                this.dialog = false;
            },

            onCancel() {
                this.dialog = false;
            },

            canRead(claim) {
                return securityService.hasClaim(claim);
            },

            canEdit(claim) {
                return securityService.hasClaim(claim, true);
            },

            itemMatches(item, tokens) {
                for (var i = 0; i < tokens.length; i++) {
                    var token = tokens[i];
                    var isMatch =
                        this.includes(item.membershipNumber, token) ||
                        this.includes(this.contacts[item.contactId], token);

                    if (!isMatch) {
                        return false;
                    }
                }
                return true;
            },

            includes(value, token) {
                if (!value) {
                    return false;
                }

                return ('' + value).toLowerCase().includes(token);
            }
        },

        computed: {
            filteredHeaders() {
                var filter = this.filter;

                if (typeof filter === 'undefined' || filter === null) {
                    return this.headers;
                }

                return this.headers.filter(h => !filter.hasOwnProperty(h.value));
            },

            computedItems() {
                var search = this.search;
                var tokens = search.toLowerCase().trim().split(' ');

                if (tokens.length < 1) {
                    return this.items;
                }

                return this.items.filter(i => this.itemMatches(i, tokens));
            }
        }
    };
</script>
